import { useEffect, useState } from 'react';

import { useGetTreatment, useSplitContext } from '@zg-rentals/split';

import SplitTestConstants from '../constants/SplitTestConstants';
import accessUtils from '../utils/accessUtils';
import { useSelector } from '../selectors/useSelector';

const useAccessPropertyDescriptionReorder = () => {
  const {
    split: { experiments: splitExperiments },
  } = useSplitContext();

  const cookieEnabledServices = useSelector((state) => state.app.cookieEnabledServices);

  const [canAccessPropertyDescriptionReorder, setCanAccessPropertyDescriptionReorder] = useState<boolean | null>(null);

  const {
    data: getTreatmentData,
    isFetching: isGetTreatmentFetching,
    isLoading: isGetTreatmentLoading,
    refetch: refetchGetTreatment,
  } = useGetTreatment(
    {
      featureName: SplitTestConstants.ZRM_PROPERTY_DESCRIPTION_REORDER,
    },
    {
      enabled: false,
      refetchOnMount: false,
    },
  );

  useEffect(() => {
    if (!getTreatmentData && !isGetTreatmentFetching) {
      refetchGetTreatment();
    }
  }, []);

  // splitExperiments needs to have the experiment name as a property to check the treatment value
  const splitExperimentsHasOwnProperty = splitExperiments.hasOwnProperty(
    SplitTestConstants.ZRM_PROPERTY_DESCRIPTION_REORDER,
  );

  useEffect(() => {
    if (
      isGetTreatmentLoading === false &&
      splitExperimentsHasOwnProperty &&
      canAccessPropertyDescriptionReorder === null
    ) {
      const canAccessResponse = accessUtils.canAccessPropertyDescriptionReorder({
        splitExperiments,
        cookieEnabledServices,
      });

      setCanAccessPropertyDescriptionReorder(canAccessResponse);
    }
  }, [isGetTreatmentLoading, splitExperimentsHasOwnProperty]);

  return {
    canAccessPropertyDescriptionReorder,
    isPropertyDescriptionReorderLoading: canAccessPropertyDescriptionReorder === null,
  };
};

export default useAccessPropertyDescriptionReorder;
